module.exports = __webpack_public_path__ + "static/media/treadly-bg.71a8bd5e.jpg";